// extracted by mini-css-extract-plugin
export default {"main":"WhySection_main__OMjEk","whyContainer":"WhySection_whyContainer__oglna","cardGrid":"WhySection_cardGrid__INVNu"};